import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { GET, POST, httpOk } from 'helpers/api'

/**
 * Массовая выдача права всем сотрудникам с выбранной ролью.
 *
 * Роль и право выбираются из справочников: раньше и то и другое вводилось
 * строкой, и опечатка в значении права давала пустой прогон без единой
 * ошибки — казалось, что право выдано.
 */
function PermissionsTab() {
	const { t } = useTranslation()

	const [roles, setRoles] = useState([])
	const [permissions, setPermissions] = useState([])
	const [selectedRole, setSelectedRole] = useState(null)
	const [selectedPermission, setSelectedPermission] = useState(null)
	const [result, setResult] = useState(null)

	async function getRoles() {
		const response = await GET('/helper/user-roles', {}, { loader: false })
		if (httpOk(response)) setRoles(response.data)
	}

	async function getPermissions() {
		const response = await GET('/admin/permissions', {}, { loader: false })
		if (httpOk(response)) setPermissions(response.data)
	}

	async function addPermission() {
		if (!selectedRole || !selectedPermission) {
			toast.error(t('admin_tools_select_role_permission'))
			return
		}

		setResult(null)
		const response = await POST('/admin/permission', {
			'role': selectedRole.role,
			'permission': selectedPermission.value,
		}, { loader: true, notification: false })

		if (httpOk(response)) {
			setResult(response.data)
			toast.success(response.data?.message || t('success'))
		}
	}

	useEffect(() => {
		getRoles()
		getPermissions()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div className="row">
			<div className="col-md-6">
				<div className="card">
					<div className="card-body">
						<div className="tool-section-title">
							{t('permissions')}
						</div>
						<div className="text-muted fz-12 mb-3">
							{t('admin_tools_permission_hint')}
						</div>

						<div className="row">
							<div className="form-group col-md-6">
								<label>{t('role')}</label>
								<Select
									options={roles}
									value={selectedRole}
									onChange={(option) => setSelectedRole(option)}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.role}
								/>
							</div>
							<div className="form-group col-md-6">
								<label>{t('admin_tools_permission')}</label>
								<Select
									options={permissions}
									value={selectedPermission}
									onChange={(option) => setSelectedPermission(option)}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => `${option.name} — ${option.value}`}
									getOptionValue={(option) => option.id}
								/>
							</div>
						</div>

						<button type="button" className="btn btn-primary w-100 mt-2"
							onClick={() => addPermission()}>
							{t('admin_tools_grant')}
						</button>

						{result &&
							<div className="tool-result mt-3">
								<div className="tool-result-row">
									<span>{t('admin_tools_users_total')}</span>
									<b>{result.users_total ?? 0}</b>
								</div>
								<div className="tool-result-row">
									<span>{t('admin_tools_permissions_granted')}</span>
									<b className="text-success">{result.permissions_granted ?? 0}</b>
								</div>
							</div>
						}
					</div>
				</div>
			</div>
		</div>
	)
}

export default PermissionsTab
